<template>
	<div>
		<!-- begin breadcrumb -->
		<ol class="breadcrumb float-xl-right">
			<li class="breadcrumb-item"><a href="/eventbank">Event Bank</a></li>
			<li v-if="$route.params.type" class="breadcrumb-item"><a :href="'/eventbank/' + $route.params.type">{{ $route.params.type | capitalize }}</a></li>
			<li v-if="$route.params.type && !breadcrumbImport" class="breadcrumb-item"><a :href="'/eventbank/' + $route.params.type + '/' + breadcrumb">{{ breadcrumb | capitalize }}</a></li>
            <li v-if="$route.params.id && item" class="breadcrumb-item"><a :href="'/eventbank/' + $route.params.type + '/' + breadcrumb + '/' + $route.params.id">{{ item.name }}</a></li>
            <li v-if="$route.params.id && category" class="breadcrumb-item"><a :href="'/eventbank/' + $route.params.type + '/' + breadcrumb + '/' + $route.params.id">{{ category.name }}</a></li>
            <li v-if="breadcrumbNew" class="breadcrumb-item"><a :href="'/eventbank/' + $route.params.type + '/' + breadcrumb + '/new'">New</a></li>
            <li v-if="breadcrumbEdit" class="breadcrumb-item"><a :href="'/eventbank/' + $route.params.type + '/' + breadcrumb + '/' + $route.params.id + '/edit'">Edit</a></li>
            <li v-if="breadcrumbImport" class="breadcrumb-item"><a :href="'/eventbank/' + $route.params.type + '/import'">Import</a></li>
		</ol>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">Event Bank <small>Event Bank is a home for all space, stuff, staff and support services. Create or Import your categories and items here.</small></h1>
        <router-view
            v-bind:typeId="typeId"
            v-bind:item="item"
            v-bind:items="items"
            v-bind:category="category"
            v-bind:categories="categories"
            v-bind:scriptItems="scriptItems"
            v-bind:activeEvent="activeEvent"
            v-bind:createItemCall="createItemCall"
            v-bind:removeImage="removeImage"
            v-bind:removeFile="removeFile"
        />
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { imageService } from '../services/image.service.js'
import { fileService } from '../services/file.service.js'

export default {
    name: 'EventBank',
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    computed: {
        ...mapState('item', ['items', 'item']),
        ...mapState('category', ['categories', 'category']),
        ...mapState('scriptitem', ['scriptItems']),
        ...mapState('note', ['notes']),
        ...mapState('event', ['activeEvent'])
    },
    methods: {
        ...mapActions('item', ['getItems', 'getItem', 'createItem', 'updateItem', 'deleteItem']),
        ...mapActions('category', ['getCategories', 'getCategory', 'createCategory', 'updateCategory', 'deleteCategory']),
        ...mapActions('scriptitem', ['getScriptItems']),
        ...mapActions('note', ['createNote', 'updateNote', 'deleteNote']),
        async createItemCall(itemData) {
            await this.createItem(itemData);
            await this.getItems(this.activeEvent.id);
        },
        createCategoryCall(categoryData) {
            this.createCategory(categoryData);
            this.getCategories(this.activeEvent.id);
        },
        submit(itemId, itemData) {
            this.updateItem({ itemId, itemData });
            this.$router.push("/eventbank/" + this.$route.params.type + "/items/" + this.item.id);
        },
        bulkSubmit(itemId, itemData) {
            this.updateItem({ itemId, itemData });
        },
        delete(itemId) {
            this.deleteItem(itemId);
            this.$router.push("/eventbank/" + this.$route.params.type + "/items");
        },
        bulkDelete(itemId) {
            this.deleteItem(itemId);
        },
        getItemCall() {
            this.getItem(this.$route.params.id);
        },
        submitCategory(categoryId, categoryData) {
            this.updateCategory({ categoryId, categoryData });
            this.$router.push("/eventbank/" + this.$route.params.type + "/categories/" + this.category.id);
        },
        deleteCategoryCall(categoryId) {
            this.deleteCategory(categoryId);
            this.$router.push("/eventbank/" + this.$route.params.type + "/categories");
        },
        getCategoryCall() {
            this.getCategory(this.$route.params.id);
        },
        createNoteCall(noteData) {
            this.createNote(noteData);
        },
        submitNote(noteId, noteData) {
            this.updateNote({ noteId, noteData });
        },
        deleteNoteCall(noteId) {
            this.deleteNote(noteId);
        },
        getTypeId() {
            switch (this.$route.params.type) {
                case 'service':
                    this.typeId = 1;
                    break;
                case 'space':
                    this.typeId = 2;
                    break;
                case 'staff':
                    this.typeId = 3;
                    break;
                case 'stuff':
                    this.typeId = 4;
                    break;
                default:
                    this.typeId = 0;
            }
        },
        updateBreadcrumbs() {
            if (this.$route.path.includes('items')) {
                this.breadcrumb = 'items';
            } else if (this.$route.path.includes('categories')) {
                this.breadcrumb = 'categories';
            }

            if (this.$route.path.includes('new')) {
                this.breadcrumbNew = true;
            } else {
                this.breadcrumbNew = false;
            }

            if (this.$route.path.includes('edit')) {
                this.breadcrumbEdit = true;
            } else {
                this.breadcrumbEdit = false;
            }

            if (this.$route.path.includes('import')) {
                this.breadcrumbImport = true;
            } else {
                this.breadcrumbImport = false;
            }
        },
        removeImage(imageId) {
            imageService.deleteImage(imageId);
        },
        removeFile(fileId) {
            fileService.deleteFile(fileId);
        }
    },
    watch: {
        $route () {
            this.updateBreadcrumbs();
            this.getTypeId();
        }
    },
    data() {
        return {
            breadcrumb: '',
            breadcrumbNew: false,
            breadcrumbEdit: false,
            breadcrumbImport: false,
            typeId: 0
        }
    },
    mounted() {
        this.getItems(this.activeEvent.id);
        this.getCategories(this.activeEvent.id);
        this.getScriptItems(this.activeEvent.id);
        this.updateBreadcrumbs();
        this.getTypeId();
    }
}
</script>
